export default __webpack_public_path__ + "static/logo-inverted-cb68023b9a1572c156f2ede5ecb72f26.png";